exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-review .cloneName{background-size:18px 18px;color:#373737}.image-review .imageName{font-size:1.25em;color:#373737;font-weight:500;padding:0 24px 0 32px;background:url(" + require("../../../icons/clone-icons_image.svg") + ") no-repeat 0 0;background-size:24px 24px;background-position:0 9px}.image-review .backupLocation{font-size:.85em;padding:0 24px 0 32px;background:url(" + require("../../../icons/clone-icons_folder-location.svg") + ") no-repeat 0 0;background-size:18px 18px}.image-review .backupFile{font-size:.85em;padding:0 24px 0 32px;background:url(" + require("../../../icons/clone-icons_backup.svg") + ") no-repeat 0 0;background-size:18px 18px}.image-review .database-list{list-style:none;margin:0}.image-review .database-list li.database-list-item{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/imaging/ImageCreationConfirmationPage/index.scss
// module id = 1031
// module chunks = 0